<!-- fixes/14757: original row/column classes before layout adjustment -->
<!-- <div class="row mt-3 d-flex align-items-center"> -->
<!-- <div class="col"> -->
<div class="row mt-3">
  <div class="col-12 d-flex align-items-center gap-4">
    <div class="d-flex align-items-center gap-2">
      <p-radiobutton
        inputId="addTrackingTypeFedex"
        name="addTrackingType"
        value="fedex"
        [(ngModel)]="trackingType"
        (onClick)="onTrackingTypeChange()" />
      <label class="form-check-label mt-1 mb-0" for="addTrackingTypeFedex">
        FedEx/UPS
      </label>
    </div>
    <div class="d-flex align-items-center gap-2">
      <p-radiobutton
        inputId="addTrackingTypeOther"
        name="addTrackingType"
        value="other"
        [(ngModel)]="trackingType"
        (onClick)="onTrackingTypeChange()" />
      <label class="form-check-label mt-1 mb-0" for="addTrackingTypeOther">
        Other
      </label>
    </div>
  </div>
</div>

<div class="row mt-3 align-items-center" *ngIf="trackingType === 'fedex'">
  <div class="col-3">
    <div class="form-group has-float-label">
      <label class="form-label">Vendor SKU</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        [(ngModel)]="vendorSKU"
        readonly />
    </div>
  </div>
  <!-- fixes/14757: original class was <div class="col"> -->
  <div class="col-3">
    <div class="form-group has-float-label">
      <label class="form-label">Quantity</label>
      <input
        jniAutoCompleteBlocker
        type="number"
        class="form-control"
        [(ngModel)]="lineQuantity" />
    </div>
  </div>
  <!-- fixes/14757: original class was <div class="col"> -->
  <div class="col-3">
    <div class="form-group has-float-label">
      <label class="form-label">Tracking Number</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        [(ngModel)]="trackingNumber" />
    </div>
  </div>
  <!-- fixes/14757: original class was <div class="col"> -->
  <div class="col-auto">
    <div class="form-check d-flex align-items-center p-0 gap-2 mt-4 pt-1">
      <!-- <input
        class="form-check-input me-2 no-bg"
        type="checkbox"
        id="check1"
        [checked]="isMasterTracking"
        name="Eco-Friendly Business"
        (change)="onMasterTrackingCheckChange()" /> -->

      <p-checkbox
        [binary]="true"
        [(ngModel)]="isMasterTracking"
        name="Eco-Friendly Business" />

      <label class="form-check-label" for="check1" class="mt-1">
        Master Tracking
      </label>
    </div>
  </div>
  <!-- fixes/14757: original class was <div class="col-3 mt-4"> -->
  <div class="col-auto mt-4 ms-auto">
    <!-- <button class="btn btn-primary" (click)="addTracking()">Add</button> -->
    <p-button label="Add" (click)="addTracking()" />
  </div>
</div>

<div class="row mt-3 align-items-center" *ngIf="trackingType === 'other'">
  <div class="col-3">
    <div class="form-group has-float-label">
      <label class="form-label">Shipping Method</label>
      <p-select
        id="addTrackingOtherShippingMethod"
        [(ngModel)]="otherShippingMethod"
        [options]="otherShippingMethods"
        optionLabel="shippingMethod"
        optionValue="code"
        appendTo="body"
        [filter]="true"
        [showClear]="true"
        styleClass="w-100"
        placeholder="Select" />
    </div>
  </div>
  <div class="col-3">
    <div class="form-group has-float-label">
      <label class="form-label">Tracking Number</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        [(ngModel)]="trackingNumber" />
    </div>
  </div>
  <div class="col-auto mt-4">
    <p-button label="Add" (click)="addTracking()" />
  </div>
</div>
<div class="row mt-3">
  <jni-tracking-list
    [workflowTrackingList]="pageTrackingList"
    (deleteTrackingRecordEvent)="deleteTrackingRecord($event)"
    (deleteRowEvent)="deleteRow($event)">
  </jni-tracking-list>
</div>

<div class="d-flex pt-2 justify-content-end gap-2">
  <p-button
    label="Save"
    (click)="saveTrackingList()"
    [disabled]="!saveButtonEnabled" />

  <p-button
    label="Close"
    (click)="closeModalDialog()"
    variant="outlined"
    severity="secondary" />

  <!-- <button
        type="button"
        (click)="saveTrackingList()"
        class="btn  btn-primary me-3"
        [disabled]="!saveButtonEnabled"
        >
        Save
    </button>
    <button
        type="button"
        (click)="closeModalDialog()"
        class="btn btn-secondary me-3"
        >
        close
    </button> -->
</div>
